"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentGraduationYearContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const student_graduation_year_image_svg_1 = __importDefault(require("../../assets/images/student-graduation-year-image.svg"));
const FlatButton_1 = require("../../atoms/FlatButton/FlatButton");
const SelectableButton_1 = require("../../atoms/SelectableButton/SelectableButton");
const Title_1 = require("../../atoms/Title/Title");
const FormData_1 = require("../../context/FormData");
const Progress_1 = require("../../context/Progress");
const mediaQueries_1 = require("../../styles/mediaQueries");
const SurveyPageContentTemplate_1 = require("../../templates/SurveyPageContentTemplate/SurveyPageContentTemplate");
// eslint-disable-next-line max-lines-per-function
function StudentGraduationYearContent(props) {
    const { t } = (0, i18n_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [{ nextRoute }, dispatch] = (0, Progress_1.useProgress)();
    const [formDataState, dispatchFormData] = (0, FormData_1.useFormData)();
    const [hasNavigated, setHasNavigated] = react_1.default.useState(false);
    const COUNT_TO_SHOW_WHEN_COLLAPSED = 6;
    const [isShowMoreButtonHidden, setIsShowMoreButtonHidden] = react_1.default.useState(false);
    const [isExpanded, setIsExpanded] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        dispatch((0, Progress_1.setNextRoute)(props.nextRoute));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, [props.nextRoute]);
    react_1.default.useEffect(() => {
        dispatch((0, Progress_1.setCurrentPage)(3));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, []);
    react_1.default.useEffect(() => {
        /**
         * Can go next only if there is a selected year
         */
        dispatch((0, Progress_1.setCanGoNext)(formDataState.year !== undefined));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- dispatch function should not be changed
    }, [formDataState.year]);
    const navigateToNextPage = () => {
        if (!nextRoute || hasNavigated) {
            return;
        }
        setHasNavigated(true);
        navigate(`../${nextRoute}`, { state: { canGoBack: true } });
    };
    const createOnYearSelect = (year) => () => {
        /**
         * User clicks on the same year button
         * Navigate to the next page without button animation
         * Don't dispatch the action to avoid unnecessary re-renders
         */
        if (formDataState.year === year) {
            navigateToNextPage();
            return;
        }
        dispatchFormData((0, FormData_1.setYear)(year));
    };
    const currentYear = new Date().getFullYear();
    const years = Array.from(Array(11).keys()).map((_, index) => currentYear + index);
    const countToShow = isExpanded ? years.length : COUNT_TO_SHOW_WHEN_COLLAPSED;
    const displayShowMoreButton = !isExpanded && years.length > countToShow;
    const onShowMoreClick = () => {
        setIsShowMoreButtonHidden(true);
    };
    const yearsButtons = years.slice(0, countToShow).map(year => ((0, jsx_runtime_1.jsx)(SelectableButton_1.SelectableButton, { selected: formDataState.year === year, onClick: createOnYearSelect(year), onAnimationEnd: isAppearing => {
            if (!isAppearing && formDataState.year === year) {
                navigateToNextPage();
            }
        }, "data-e2e": 'StudentGraduationYearContent_SelectableButton', children: year }, year)));
    return ((0, jsx_runtime_1.jsx)(SurveyPageContentTemplate_1.SurveyPageContentTemplate, { Image: student_graduation_year_image_svg_1.default, content: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TitleContainer, { children: (0, jsx_runtime_1.jsx)(StyledTitle, { children: t(i18n_1.Strings.userOnboarding.studentGraduationYear.title) }) }), (0, jsx_runtime_1.jsxs)(ButtonsContainer, { children: [yearsButtons, displayShowMoreButton && ((0, jsx_runtime_1.jsx)(FlatButton_1.FlatButton, { willUnmount: isShowMoreButtonHidden, onClick: onShowMoreClick, onUnmountAnimationEnd: () => {
                                setIsExpanded(true);
                            }, children: t(i18n_1.Strings.userOnboarding.common.showMore) }))] })] }), "data-e2e": 'StudentGraduationYearContent_SurveyPageContentTemplate' }));
}
exports.StudentGraduationYearContent = StudentGraduationYearContent;
const TitleContainer = styled_components_1.default.div `
  margin-bottom: 28px;

  ${mediaQueries_1.device.desktop `
    display: flex;
    align-items: flex-end;
    flex-shrink: 0;
    
    height: 164px;
    margin-bottom: 24px;
  `}
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  ${mediaQueries_1.device.desktop `
    text-align: left;
  `}
`;
const ButtonsContainer = styled_components_1.default.div `
  width: 100%;

  box-sizing: border-box;
  padding: 16px 8px 16px 16px;

  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: auto;

  & button {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${mediaQueries_1.device.mobileLandscape `
    width: max-content;
    
    & button {
      width: 280px;
    }
  `}

  ${mediaQueries_1.device.desktop `
    width: 100%;

    padding: 16px 8px 16px 16px;
    margin: 0 -16px -16px;

    & button {
      width: 100%;
    }
  `}
`;
